module.exports = __webpack_public_path__ + "media/categories/404-33de3701.svg";